module.exports = __webpack_public_path__ + "ruler-ico2.png?e63867fe01a0af62d56a6eea5784c62c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ruler-ico2.png
// module id = 27
// module chunks = 0